/**
 * Maps Firebase auth error codes to user-friendly messages.
 * Customise these messages to match your gym's tone of voice.
 */
const AUTH_ERROR_MESSAGES = {
	// Login errors
	"auth/invalid-credential": "Incorrect email or password. Please try again.",
	"auth/wrong-password": "Incorrect password. Please try again.",
	"auth/user-not-found": "No account found with that email address.",
	"auth/user-disabled":
		"This account has been disabled. Please contact your trainer.",
	"auth/too-many-requests":
		"Too many failed attempts. Please wait a moment and try again.",
	"auth/invalid-email": "Please enter a valid email address.",

	// Registration errors
	"auth/email-already-in-use":
		"An account with this email already exists. Try logging in instead.",
	"auth/weak-password":
		"Password is too weak. Please use at least 6 characters.",
	"auth/operation-not-allowed":
		"Registration is currently disabled. Please contact your trainer.",

	// Password reset errors
	"auth/missing-email": "Please enter your email address.",
	"auth/user-not-found-reset":
		"If an account exists with that email, a reset link has been sent.",

	// Network / general errors
	"auth/network-request-failed":
		"Network error. Please check your connection and try again.",
	"auth/internal-error":
		"Something went wrong on our end. Please try again shortly.",
	"auth/requires-recent-login":
		"For security, please log out and log back in before making this change.",
};

/**
 * Returns a friendly error message for a Firebase auth error.
 * Falls back to a generic message if the code isn't mapped.
 */
export function getFriendlyAuthError(
	error,
	fallback = "Something went wrong. Please try again.",
) {
	if (!error) return fallback;

	// If it's already one of our custom-thrown messages (no Firebase code), pass it through
	if (!error.code) return error.message || fallback;

	return AUTH_ERROR_MESSAGES[error.code] || fallback;
}
